module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/zh-hant/2-4877a135826b8e98575ac6d665b35028.jpg";